module.exports = __webpack_public_path__ + "img/verde.c39fdd8a.jpg";